/* jslint esversion: 6 */
/**
 * Max-Width Table
 *
 * Enable tables to scroll within a max-width container element.
 *
 * @requires styles _max-width-table.scss
 * @author Dylan James Wagner
 */
const $ = window.jQuery;
const s = {
	scope    : $('.wysiwyg'), // $('main'),
	selector : 'table',
	exclude  : [              // valid :not selectors
		'table table',
		// 'table:nth-child(2)',
		// '[class^="gfield_list"]',
	],
};

function init() {

	$(wrapTables).promise().done(function() {

		events();

	});
}

function events() {

	$(window).on('load resize', function() {

		$('.max-width-table').each(function() {
			const $container      = $(this);
			const $containerInner = $container.children('.max-width-table__inner');

			const $scrollable = $containerInner;

			setShadows($container);

			$scrollable.on('scroll', function() {
				setShadows($container);
			});
		});
	});
}

function wrapTables() {

	if (s.exclude.length) {
		s.exclude.forEach(function(value, key) {
			s.selector += ':not(' + value + ')';
		});
	}

	s.scope.find(s.selector).each(function() {
		const table = $(this);
			table.next(':empty').remove(); // remove WordPress/Tiny MCE habit of adding an empty line/paragraph after a table
			// table.wrap('<div class="max-width-table"></div>');
			// table.wrap('<div class="max-width-table__inner"></div>');
			table.wrap('<div class="max-width-table"><div class="max-width-table__inner"></div></div>');
	});
}

function setShadows(element) {
	const $container      = $(element);
	const $containerInner = $container.children('.max-width-table__inner');

	const $scrollable = $containerInner;

	const $table = $container.find('table');

	const widthScrollable = Math.floor(parseFloat($scrollable.css('width')));
	const widthTable      = Math.floor(parseFloat($table.css('width')));

	if (widthTable > widthScrollable) {

		if ($scrollable.scrollLeft() > 3) {
			$container.addClass('max-width-table--left');
		}
		else {
			$container.removeClass('max-width-table--left');
		}

		if ($scrollable.scrollLeft() < (widthTable - widthScrollable - 3)) {
			$container.addClass('max-width-table--right');
		}
		else {
			$container.removeClass('max-width-table--right');
		}
	}
	else {
		$container.removeClass('max-width-table--left');
		$container.removeClass('max-width-table--right');
	}
}

export {init as default};
